import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SelectableCategory } from '../../../models/categories/category.models';

@Component({
    selector: 'mat-category-tree-item',
    template: require('./mat.tree.item.html')
})
export class MatCategoryTreeItem implements OnDestroy {
    private static modalCounter = 0;
    private _category: SelectableCategory;

    dialogHeader: string;
    dialogBody: string;
    modalId = `max-categories-modal-${MatCategoryTreeItem.modalCounter++}`;

    @Input()
    set category(category: SelectableCategory) {
        this._category = category;
    }

    get category() {
        return this._category;
    }

    @Output() selectedChanged = new EventEmitter<any>();

    toggleExpandNode() {
        this._category.isExpanded = !this._category.isExpanded;
    }

    ngOnInit() {
        this.dialogHeader = localStorage.getItem('categoriesDialogHeader');
        this.dialogBody = localStorage.getItem('categoriesDialogBody');

        var modal = this.getModal();
        modal.appendTo('body');
        modal.modal({ show: false, backdrop: false });
    }

    ngOnDestroy() {
        this.getModal().remove();
    }

    onSelectedChanged() {

        var tooManyCategoriesSelected = localStorage.getItem('tooManyCategoriesSelected');
        var categoriesSelected = +localStorage.getItem('categoriesSelected');
        var maxCategories = +localStorage.getItem('maxCategories');

        if (maxCategories == 0) {
            maxCategories = 1000;
        }

        if (tooManyCategoriesSelected == "false" || tooManyCategoriesSelected == null) {

            var categoriesToAdd = this.category.children.length;

            if ((categoriesSelected + categoriesToAdd > maxCategories) && this.category.isSelected == true) {
                this.getModal().modal('show');
                this.category.isSelected = false;
            }
            else {
                this.category.children.forEach((child: SelectableCategory) => {
                    child.isSelected = this.category.isSelected;
                });
            }
        }
        else {

            if (this.category.isSelected) {
                this.getModal().modal('show');
                this.category.isSelected = false;
            }

            this.category.children.forEach((child: SelectableCategory) => {
                child.isSelected = false;
            });
        }

        if (this.category.isSelected) {
            this.category.isExpanded = true;
        }

        this.selectedChanged.emit(this.category);
    }

    onUpdateSelected(child) {

        var tooManyCategoriesSelected = localStorage.getItem('tooManyCategoriesSelected');

        if (child.isSelected) {
            if (tooManyCategoriesSelected == "true") {
                child.isSelected = false;
                this.getModal().modal('show');
            }
        }

        this.selectedChanged.emit();
    }

    private getModal() {
        return $('#' + this.modalId);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/category.tree.view/mat.tree.item.ts